import React, { useEffect, useState } from 'react';

type OwnProps = {
  alt: string;
  blob: Blob; // eslint wants this mandatory, so we make it mandatory
};

// these are the props we take from image-element. we take all of them,
// except two:
// - src: we forbid this one. we will create it from the Blob
// - alt: we handle it by ourselves in OwnProps
type ImageProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'>;

export type Props = OwnProps & ImageProps;

export const BlobImage = ({ alt, blob, ...props }: Props) => {
  const [imageURL, setImageURL] = useState<string | null>(null);

  useEffect(() => {
    const url = URL.createObjectURL(blob);

    setImageURL(url);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [blob]);

  if (imageURL === null) {
    return null;
  }

  return <img {...props} alt={alt} src={imageURL} />;
};
